import axios, { AxiosError } from 'axios';
import { AuthModel, OAuthResponse, updatedDataModel, UserModel } from './_models';
import {
  AddBuildingRequest,
  ApiResponse,
  MessageInterface,
  buildingDetailsResponse,
  IDVSessionResponse,
  PersonalInfoRequest,
  tenantDetailsResponse,
  IDVresponse,
  rentResponse,
  transactionsResponse,
  kycIndustryResponse,
  ForgotPasswordEmailRequest,
  VerifyPasswordEmailRequest,
  NodeEnvEnum,
  payRentResponse,
  AddBuildingManager,
  compnayResponse,
  UpdateBuildingRequest,
  buildingsSubdomainResponse,
  unitDetailsResponse,
  UnitRequest,
  payNumberRequest,
  payNumberResponse,
  PayNumberDetailsResponse,
  ResidentExistsResponse,
  subdomainResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  OpenOrderResponse,
  PaymentOptionRequest,
  PaymentOption,
  UpdateCardRequestBody,
  TransactionsStatusResponse,
  PaymentSummaryResponse,
  SubscriptionDetailResponse,
  InitiateMFAResponse,
  mfaResponse,
  mfaCookieResponse,
  termsResponse,
  termsRequest,
  checkConsentResponse,
  processingFeeDetailsResponse,
  mfaListResponse,
  removeMFAResponse,
  addMFAResponse,
  initiateCryptoSessionResponse,
  markIDVApplicationResponse,
  NotificationResponse,
  Transactions,
  activeBuildingsList,
  activateCreditBuilderResponse,
  activateCreditBuilderBody,
  CreditBuilderDetails,
  UnsubscribeMail,
  tenantProgressRespone,
  rntUpdateRequest,
  managerUpdateRequest,
  userPointsResponse,
  sendReferralCodeInterface,
  RewardsHistoryResponse,
  GetGiftBitBrandsResponse,
  GiftCardsDetailsResponse,
  convertAmountPoints,
  sendGiftCardResponse,
  referralListResponse,
  RentCreditOption,
  rentCreditResponse,
  redeemRentCreditResponse,
  EquifaxCreditHealthUrlResponse,
  rentAddressRequest,
  rentDetailsRequest,
  addressDetailsRequest,
  FAQResponse,
  TransactionTimelineResponse,
  UpdateDueDateTypeRequest,
  WalletHistoryResponse,
  GetDynamicOffersResponse,
  PreviewPaymentRewardsRequest,
  PreviewPaymentRewardsResponse,
  GetOffersResponse,
  Offer,
  PointCategoryName,
  ReferralStats,
  PaymentMethodType,
  UpdateLeaseDocument,
  EquifaxSubscribedBuildingResponse,
  CreatePaymentOptionResponse,
  StakeholderResponse,
  TenantCompany,
  BanksResponse,
  PadTermsResponse,
  PlaidLinkResponse,
  PlaidCallbackResponse,
  PointTasksStatsApiResponse,
  ContestStatsResponse,
  ContestTimeResponse,
  ContestLeaderboardResponse,
  ContestPrizeListResponse,
  ContestWinnerStatusResponse,
  PointTasksStats,
  NewsletterSubscriptionApiResponse,
  SkillTestData,
  SkillTestMessageResponse,
  SkillTestResponse,
} from '../helpers/utils/types';
import type {
  CreateSocialSubmissionRequest,
  UpdateSocialSubmissionRequest,
  SocialSubmissionListResponse,
} from '../helpers/utils/types';
import { axiosInstance } from '../configs/axios';
import { getStoredUTMParams } from '../helpers/utils/utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
import { BaseResponse } from '../interfaces/baseResponse';
import { handleApiError, formatApiErrorMessage, PAY_NUMBER_INACTIVE_REASONS} from '../helpers/utils/error';
import { isNotEmptyObject } from 'class-validator';
import { logThirdPartyError } from '../helpers/utils/safeSentryError';
import { UTMParams, TrackingParams } from '../helpers/utils/tracking.types';

export let APP_ENV: NodeEnvEnum;
export let API_URL: string;
export let NUVEI_ENV: string;
export let NUVEI_MERCHANT_ID: string;
export let NUVEI_MERCHANT_SITE_ID: string;
export let DESCOPE_PROJECT_ID: string;
export let HIDE_CREDIT_HEALTH: boolean = true;
/** VAPID public key for Web Push (must match backend private key for this environment). */
export let WEB_PUSH_VAPID_PUBLIC_KEY: string;
const hostname = window.location.hostname;
if (hostname.includes('localhost')) {
  NUVEI_ENV = 'int';
  NUVEI_MERCHANT_ID = '3310682875994519434';
  NUVEI_MERCHANT_SITE_ID = '241708';
  APP_ENV = NodeEnvEnum.Local;
  DESCOPE_PROJECT_ID = 'P2w4fiRTba1lJw50zL7e1RE4b7vP';
  HIDE_CREDIT_HEALTH = false;
  WEB_PUSH_VAPID_PUBLIC_KEY =
    'BADOyefsXTiO6OWgtwSqAXuR01OHwkGXSwvnWxsMwt6Uvh4Zo1TFui-dvGNi0nSOT7ItojbRew7cBpf-fPKbUdQ';
} else if (hostname.includes('staging-')) {
  NUVEI_ENV = 'int';
  NUVEI_MERCHANT_ID = '3310682875994519434';
  NUVEI_MERCHANT_SITE_ID = '241708';
  APP_ENV = NodeEnvEnum.Staging;
  DESCOPE_PROJECT_ID = 'P2wDGPE46LZVXpCYwRZfsMsba5Ni';
  HIDE_CREDIT_HEALTH = false;
  WEB_PUSH_VAPID_PUBLIC_KEY =
    'BEOtSn7iO80s_8AQYXd5H-pAODBvQxTBkPImXXC-ZiFIdllNZ3_AjzALsV48EEDJoTiO8Hal9Vjy5tz9tUBnk08';
} else {
  APP_ENV = NodeEnvEnum.Production;
  NUVEI_ENV = 'prod';
  NUVEI_MERCHANT_ID = '285181898739894717';
  NUVEI_MERCHANT_SITE_ID = '317929';
  DESCOPE_PROJECT_ID = 'P2wDH7e54lMl3pkUHJ0V6uF8IdXr';
  HIDE_CREDIT_HEALTH = false;
  WEB_PUSH_VAPID_PUBLIC_KEY =
    'BL_pa0XVnS-G6KGZ4SFb_ELdteuBLi-yTnBGHXw4p0YTEqPOEAXLpX47N7I4aciFrw0A8Y3yms8qpFnRoMW7j4I';
}

export let MANAGER_PORTAL_URL: string;

switch (APP_ENV) {
  case NodeEnvEnum.Local:
    API_URL = 'http://localhost:3000/api/v2';
    MANAGER_PORTAL_URL = 'http://localhost:3100';
    break;
  case NodeEnvEnum.Staging:
    API_URL = 'https://staging-api.tenantpay.com/api/v2';
    MANAGER_PORTAL_URL = 'https://staging-manage.tenantpay.com';
    break;
  case NodeEnvEnum.Production:
    API_URL = import.meta.env.VITE_APP_API_URL || 'https://api.tenantpay.com/api/v2';
    MANAGER_PORTAL_URL = 'https://manage.tenantpay.com';
    break;
  default:
    console.warn('Unknown environment, defaulting to production API.');
    API_URL = 'https://api.tenantpay.com/api/v2';
    MANAGER_PORTAL_URL = 'https://manage.tenantpay.com';
}

// List of API endpoints
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/user/verifyUserToken`;
export const SAVE_USER_IP_ADDRESS = `${API_URL}/user/ip-address`;
export const LOGIN_URL = `${API_URL}/login/verifyTenantLoginDetails`;
export const REGISTER_URL = `${API_URL}/user/createTenant`;
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`;
export const VERIFY_SIGNUP_URL = `${API_URL}/user/verifySignUp`;
export const VERIFY_PHONE_URL = `${API_URL}/tenant/verifyCodeOnSms`;
export const SEND_EMAIL_CODE = `${API_URL}/login/sendVerificationCode`;
export const SEND_PHONE_CODE = `${API_URL}/tenant/sendCodeOnSms`;
export const SEND_PHONE_CODE_UPDATE = `${API_URL}/verification-code/send-code/phone-number`;
export const VERIFY_PHONE_CODE_UPDATE = `${API_URL}/verification-code/verify/phone-number`;
export const UPDATE_USER_PROFILE = `${API_URL}/user/updateUserProfile`;
export const UPDATE_TENANT_URL = `${API_URL}/tenant/updateTenant`;
export const ADD_BUILDING_URL = `${API_URL}/tenant-building/addBuilding`;
export const IDV_SESSION_URL = `${API_URL}/tenant/createIdvSession`;
export const GET_TENANT_DETAILS = `${API_URL}/tenant/getTenantByUserId`;
export const GET_BUILDING_DETAILS = `${API_URL}/tenant-building/getBuildingsByUserId`;
export const DIRECT_PAYMENT_TOKEN_API = `${API_URL}/payment/direct`;
export const AUTH_PAYMENT_TOKEN_API = `${API_URL}/payment/paymentOption/auth`;
export const AUTH_PAYMENT = `${API_URL}/payment/auth`;
export const GET_IDV_STATUS = `${API_URL}/tenant/idvStatus`;
export const GET_RENT_PAID = `${API_URL}/tenant-building/getTotalRentPaid`;
export const GET_TRANSACTIONS = `${API_URL}/tenant-transaction/list`;
/** Tenant-scoped stats (success, debit, non-refunded sale transactions). */
export const GET_TENANT_TRANSACTION_TENANT_STATS = `${API_URL}/tenant-transaction/tenant/stats`;
export const GET_INDUSTRY_MENU = `${API_URL}/kyc/businessTypes`;
export const FORGOT_PASSWORD_EMAIL_URL = `${API_URL}/login/forgotPasswordEmail`;
export const VERIFY_PASSWORD_EMAIL_URL = `${API_URL}/login/forgotPasswordReset`;
export const PAY_RENT = `${API_URL}/payment/tenant/rent`;

export const UPDATE_BUILDING = `${API_URL}/tenant-building/updateBuilding`;
export const UPDATE_BUILDING_STATUS = `${API_URL}/tenant-building`;
export const ADD_BUILDING_MANAGER_URL = `${API_URL}/tenant-building/manager`;
export const GET_COMPANY_SETTING = `${API_URL}/company-setting`;
export const GET_BUILDINGS_SUBDOMAIN = `${API_URL}/select/building/subdomain`;
export const GET_UNITS_SUBDOMAIN = `${API_URL}/select/unit/subdomain`;
export const CREATE_UNIT = `${API_URL}/unit`;
export const GENERATE_PAY_NUMBER = `${API_URL}/resident/pay-number`;
export const GET_SUBDOMAIN_STATUS = `${API_URL}/subdomain/validate`;
export const VALIDATE_PAY_NUMBER = `${API_URL}/resident/validate-pay-number`;
export const CHECK_RESIDENT_EXISTS = `${API_URL}/resident/exists`;
export const GET_DETAILS_BY_PAY_NUMBER = (payNumber: string) =>
  `${API_URL}/resident/payNumber/${payNumber}`;
export const LOGIN_RESET_PASSWORD = `${API_URL}/login/resetPassword`;
export const CREATE_PAYMENT_OPTION = `${API_URL}/payment/paymentOption`;
export const UPDATE_PAYMENT_OPTION = `${API_URL}/payment/paymentOption`;
export const GET_PAYMENT_OPTIONS = `${API_URL}/payment/paymentOption`;
export const GET_BUILDING_BY_ID = `${API_URL}/tenant-building/getBuildingsByUserId`;
export const UPDATE_CARD_DETAILS = `${API_URL}/payment/paymentOption`;
export const REMOVE_CARD = `${API_URL}/payment/paymentOption`;
export const VERIFY_PAYMENT_OPTION = (id: string) =>
  `${API_URL}/payment/paymentOption/${id}/verify`;
export const getTransactionStatusUrl = (id: string) =>
  `${API_URL}/tenant-transaction/tenant-buildings/${id}/payment-schedule`;

export const INITIATE_MFA = `${API_URL}/mfa/initiate/phone-number`;
export const INITIATE_MFA_EMAIL = `${API_URL}/mfa/initiate/email`;
export const VERIFY_MFA = `${API_URL}/mfa/verify/phone-number`;
export const VERIFY_MFA_EMAIL = `${API_URL}/mfa/verify/email`;
export const CREATE_JWT = `${API_URL}/login/token`;
export const LOGOUT_URL = `${API_URL}/login/logout`;
export const GET_MFA_STATUS = `${API_URL}/mfa/validate`;
export const GET_TERMS_CONTENT = `${API_URL}/terms-and-conditions?name=tenantTermsAndCondition`;
export const CHECK_CONSENT = `${API_URL}/terms-and-conditions/check-user-consent?name=tenantTermsAndCondition`;
export const SET_USER_CONSENT = `${API_URL}/terms-and-conditions/user-consent`;
export const GET_PROCESSING_FEE_DETAILS = `${API_URL}/payment/tenant/processing-fee`;
export const GET_BANKS = `${API_URL}/bank`;
export const GET_PAD_TERMS = (name: string) => `${API_URL}/pad-authorizations?name=${name}`;
export const PLAID_LINK_API = `${API_URL}/plaid/link`;
export const PLAID_CALLBACK_API = `${API_URL}/plaid/callback`;
export const GET_MFA_ENABLED_LIST = `${API_URL}/mfa/user`;
export const REMOVE_MFA = `${API_URL}/mfa`;
export const ADD_MFA = `${API_URL}/mfa`;
export const ALT5 = `${API_URL}/alt5`;
export const IDV_APPLICATION = `${API_URL}/tenant/tenant-idv`;
const OAUTH_URL = `${API_URL}/oauth`;
const NOTIFICATION_URL = `${API_URL}/notification`;
const PUSH_NOTIFICATIONS_URL = `${API_URL}/push-notifications`;
const TENANT_TRANSACTIONS = `${API_URL}/tenant-transaction`;
const ACTIVE_BUILDINGS = `${API_URL}/equifax/eligibleBuildings`;
const SUBSCRIBED_BUILDINGS = `${API_URL}/equifax/subscribedBuildings`;
const SUBSCRIBE_CREDIT_BUILDER = `${API_URL}/equifax`;
const UNSUBSCRIBE_MAIL = `${API_URL}/unsubscribe`;
const MAILER_UNSUBSCRIBE_URL = `${API_URL}/mailer/unsubscribe`;
const GET_TENANT_PROGRESS = `${API_URL}/dashboard/tenant/progress`;
const GET_USER_POINTS = `${API_URL}/point`;
const NEWSLETTERS_URL = `${API_URL}/newsletters`;
const POINT_TASKS = `${API_URL}/point-tasks`;
export const CONTEST_TIME_URL = `${API_URL}/contests/time`;
export const CONTEST_STATS_URL = `${API_URL}/contests/stats`;
export const CONTEST_LEADERBOARD_URL = `${API_URL}/contests/leaderboard`;
export const CONTEST_PRIZES_URL = `${API_URL}/contests/prizes`;
export const CONTEST_STATUS_URL = `${API_URL}/contests/status`;
const SKILL_TESTS_URL = `${API_URL}/skill-tests`;
const POINT_RANK_URL = `${API_URL}/point/rank`;
const GET_REFERRAL_LINK = `${API_URL}/referral/link`;
const SEND_REFERRAL_CODE = `${API_URL}/referral/invite`;
const VALIDATE_REFERRAL_CODE = `${API_URL}/referral/isValidCode`;
const GIFTBIT = `${API_URL}/giftbit`;
const GET_REFERRAL_LIST = `${API_URL}/referral/list`;
const SOCIAL_SUBMISSIONS_URL = `${API_URL}/social-submissions`;
const RENT_CREDIT = `${API_URL}/rent-credit`;
const SAVE_RENT_CREDIT = `${API_URL}/point/reedeem/rentCredit`;
const E_VOUCHERS = `${API_URL}/e-vouchers`;
const EQUIFAX_CREDIT_HEALTH = `${API_URL}/equifax-credit-health`;
const GET_FAQ = `${API_URL}/faq`;
const TENANT_SUBSCRIPTION = `${API_URL}/tenant-subscriptions`;
const TENANT_EMAILS = `${API_URL}/tenant-emails`;
const GET_TRANSACTION_TIMELINE = `${API_URL}/transaction-timelines/tenant-transactions`; // Server should return AuthModel
const GET_REFERRAL_STATS = `${API_URL}/referral/stats`;
const GET_PROCESS_DATE = `${API_URL}/tenant-transaction/process-date`;
const TENANT_COMPANY = `${API_URL}/tenant-company`;
const KYC_BUSINESS_TYPE = `${API_URL}/kyc/businessTypes`;
const TENANT_STAKEHOLDER = `${API_URL}/tenant-stakeholder`;
const PROMO_CODES = `${API_URL}/promo-codes`;

// External API endpoints
export const IPIFY_API_URL = 'https://api.ipify.org?format=json';

export function login(email: string, password: string) {
  return axiosInstance.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  });
}

export function logout() {
  return axiosInstance.post<MessageInterface>(LOGOUT_URL);
}

// Server should return AuthModel
interface RegisterPayload {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  utm?: UTMParams;
  tracking?: TrackingParams;
  referralCode: string;
  acquisitionSource?: string;
}

export async function register(
  email: string,
  password: string,
  referralCode: string,
  acquisitionSource?: string
) {
  try {
    const { utm, tracking } = getStoredUTMParams();
    const firstName = '';
    const lastName = '';

    const utmParams: UTMParams = {};
    if (utm.source) utmParams.source = utm.source;
    if (utm.medium) utmParams.medium = utm.medium;
    if (utm.campaign) utmParams.campaign = utm.campaign;
    if (utm.term) utmParams.term = utm.term;
    if (utm.content) utmParams.content = utm.content;

    const trackingParams: TrackingParams = {};
    if (tracking) {
      if (tracking.gclid) trackingParams.gclid = tracking.gclid;
      if (tracking.fbclid) trackingParams.fbclid = tracking.fbclid;
      if (tracking.msclkid) trackingParams.msclkid = tracking.msclkid;
      if (tracking.ttclid) trackingParams.ttclid = tracking.ttclid;
      if (tracking.liFatId) trackingParams.liFatId = tracking.liFatId;
      if (tracking.twclid) trackingParams.twclid = tracking.twclid;
      if (tracking.gbraid) trackingParams.gbraid = tracking.gbraid;
      if (tracking.wbraid) trackingParams.wbraid = tracking.wbraid;
      if (tracking.utmId) trackingParams.utmId = tracking.utmId;
      if (tracking.referrerUrl) trackingParams.referrerUrl = tracking.referrerUrl;
      if (tracking.referrerDomain) trackingParams.referrerDomain = tracking.referrerDomain;
    }

    const payload: RegisterPayload = {
      email,
      firstName,
      lastName,
      password,
      referralCode,
    };

    if (Object.keys(utmParams).length > 0) {
      payload.utm = utmParams;
    }

    if (Object.keys(trackingParams).length > 0) {
      payload.tracking = trackingParams;
    }

    if (acquisitionSource) {
      payload.acquisitionSource = acquisitionSource;
    }

    const response = await axiosInstance.post<AuthModel>(REGISTER_URL, payload);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { errorMessage, message } = axiosError.response.data;

        if (message === 'phone_number_blocked') {
          throw new Error('phone_number_blocked');
        }
        const hasInvalidEmail =
          message === 'invalid_email' ||
          ([] as string[]).concat(errorMessage ?? []).some((m) => m.includes('invalid_email'));
        if (hasInvalidEmail) {
          throw new Error('invalid_email');
        }
        if (message === 'email_domain_blocked') {
          throw new Error('email_domain_blocked');
        }
        if (
          Array.isArray(errorMessage) &&
          errorMessage.includes('phoneNumber must be a valid phone number')
        ) {
          throw new Error('invalid phoneNumber');
        } else if (errorMessage?.includes('email_already_exist')) {
          throw new Error('email already registered');
        }

        throw new Error(`Registration error: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Registration error: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axiosInstance.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  });
}

export function getUserByToken(token: string) {
  return axiosInstance.post<UserModel>(
    GET_USER_BY_ACCESSTOKEN_URL,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function verifyVerificationCodeEmail(email: string, token: string, code: string) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      VERIFY_SIGNUP_URL,
      {
        request: {
          email: email,
          verificationCode: code,
          digit: 4,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error verifying code: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying code: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
}
export const sendVerificationCodeEmail = async (
  email: string | undefined,
  digit: 4,
  token: string | undefined
) => {
  try {
    digit = 4;
    const response = await axiosInstance.post<void>(
      SEND_EMAIL_CODE,
      { email, digit },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 201) {
      return;
    } else {
      console.error('Failed to send verification code:', response.data);
    }
  } catch (error) {
    console.error('Error sending verification code:', error);
  }
};
export async function updateUserProfile(token: string | undefined, userData: updatedDataModel) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      UPDATE_USER_PROFILE,
      { request: userData },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating profile: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating profile: ${error.message}`);
      }
    } else {
      throw new Error(`Error updating profile: ${error}`);
    }
  }
}
export const sendVerificationCodePhone = async (
  phoneNumber: string | undefined,
  digit: 4,
  token: string | undefined
) => {
  try {
    digit = 4;
    const response = await axiosInstance.post<void>(
      SEND_PHONE_CODE,
      { phoneNumber, digit },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      return;
    } else {
      console.error('Failed to send verification code:', response.data);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const message = axiosError.response?.data?.message;
      if (message === 'phone_number_blocked') {
        throw new Error('phone_number_blocked');
      }
    }
    console.error('Error sending verification code:', error);
    throw error;
  }
};
export async function verifyVerificationCodePhone(
  phoneNumber: string,
  token: string,
  code: string
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      VERIFY_PHONE_URL,
      {
        phoneNumber: phoneNumber,
        verificationCode: code,
        digit: 4,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          Origin: APP_ENV,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { message, errorMessage } = axiosError.response.data;
        if (message === 'phone_number_already_verified') {
          return { message: 'phone_number_already_verified' };
        }
        if (
          Array.isArray(errorMessage) &&
          errorMessage.includes('phoneNumber must be a valid phone number')
        ) {
          throw new Error('invalid phoneNumber');
        }
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error verifying code: ${message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying code: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
}

export const sendVerificationCodePhoneUpdate = async (
  phoneNumber: string | undefined,
  digit: 4,
  token: string | undefined
) => {
  try {
    digit = 4;
    const response = await axios.post<void>(
      SEND_PHONE_CODE_UPDATE,
      { phoneNumber, digit },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      return;
    } else {
      console.error('Failed to send verification code:', response.data);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const message = axiosError.response?.data?.message;
      if (message === 'phone_number_blocked') {
        throw new Error('phone_number_blocked');
      }
    }
    console.error('Error sending verification code:', error);
    throw error;
  }
};

export const verifyVerificationCodePhoneUpdate = async (
  phoneNumber: string,
  token: string,
  code: string
) => {
  try {
    const response = await axios.post<ApiResponse>(
      VERIFY_PHONE_CODE_UPDATE,
      {
        phoneNumber: phoneNumber,
        verificationCode: code,
        digit: 4,
      },
      {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { message } = axiosError.response.data;
        switch (message) {
          case 'invalid_verification_code':
            return { message: 'invalid_verification_code' };
          case 'phone_number_does_not_exist':
            return { message: 'phone_number_does_not_exist' };
          case 'verification_code_expired':
            return { message: 'verification_code_expired' };
          case 'verification_attempts_exceeded':
            return { message: 'verification_attempts_exceeded' };
          default:
            console.error('Axios error response data:', axiosError.response.data);
            throw new Error(`Error verifying code: ${message}`);
        }
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying code: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
};

export async function updateTenantDetails(
  token: string | undefined,
  request: { tenantDetails: { accountType: string; isNewProperty?: boolean } }
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(UPDATE_TENANT_URL, request, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating tenant: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating tenant: ${error.message}`);
      }
    } else {
      throw new Error(`Error updating tenant: ${error}`);
    }
  }
}
export async function disableOwnTenantAccount(token: string | undefined) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${API_URL}/tenant/disable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      throw new Error(
        axiosError.response?.data?.message
          ? `Error deleting account: ${axiosError.response.data.message}`
          : `Error deleting account: ${error.message}`
      );
    }
    throw new Error(`Error deleting account: ${error}`);
  }
}
export async function updatePersonalInfo(token: string | undefined, request: PersonalInfoRequest) {
  if (request.userDetails) {
    Object.keys(request.userDetails).forEach((key) => {
      if (
        request.userDetails &&
        request.userDetails[key as keyof typeof request.userDetails] === ''
      ) {
        request.userDetails[key as keyof typeof request.userDetails] = undefined;
      }
    });
  }
  try {
    const response = await axiosInstance.patch<ApiResponse>(UPDATE_TENANT_URL, request, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating tenant Personal Info: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating tenant Personal Info: ${error.message}`);
      }
    } else {
      throw new Error(`Error updating tenant Personal Info: ${error}`);
    }
  }
}
export async function addBuilding(token: string | undefined, requestBody: AddBuildingRequest) {
  try {
    const response = await axiosInstance.post<ApiResponse>(ADD_BUILDING_URL, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        if (errorMessage === 'resident_not_found') {
          throw new Error('payNumber_not_found');
        } else {
          throw new Error(`Error adding building: ${errorMessage}`);
        }
      } else {
        throw new Error(`Error adding building: ${error.message}`);
      }
    } else {
      throw new Error(`Error adding building: ${error}`);
    }
  }
}

export async function createIDVSession(token: string | undefined) {
  try {
    const response = await axiosInstance.post<IDVSessionResponse>(
      IDV_SESSION_URL,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (
        axiosError.response &&
        axiosError.response.data.message === 'tenant_is_already_approved'
      ) {
        throw new Error('Tenant is already approved');
      }
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error creating IDV session: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error creating IDV session: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error creating IDV session: ${error}`);
    }
  }
}
export async function getTenantDetails(token: string | undefined) {
  try {
    const response = await axiosInstance.get<tenantDetailsResponse>(GET_TENANT_DETAILS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<tenantDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting tenant details: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting tenant details: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting tenant details: ${error}`);
    }
  }
}
export async function getBuildingDetails(token: string | undefined) {
  try {
    const response = await axiosInstance.get<buildingDetailsResponse>(GET_BUILDING_DETAILS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<buildingDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting building details: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting building details: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting building details: ${error}`);
    }
  }
}
export async function getIDVStatus(token: string | undefined) {
  try {
    const response = await axiosInstance.get<IDVresponse>(GET_IDV_STATUS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<IDVresponse>;
      if (axiosError.response && axiosError.response.data) {
        if (axiosError.response.data.message === 'session_id_not_found') {
          throw new Error(`Error getting IDV status: ${axiosError.response.data.message}`);
        }
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting IDV status: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting IDV status: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting IDV status: ${error}`);
    }
  }
}

export async function getRentPaid(token: string | undefined) {
  try {
    const response = await axiosInstance.get<rentResponse>(GET_RENT_PAID, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<rentResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting Rent Paid: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting Rent Paid: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting Rent Paid: ${error}`);
    }
  }
}
export type TransactionOrderBy =
  | 'amountPaid_ASC'
  | 'amountPaid_DESC'
  | 'timestampAdded_ASC'
  | 'timestampAdded_DESC';

export type TransactionStatus =
  | 'success'
  | 'failed'
  | 'pending'
  | 'refund'
  | 'processedAsInternalPayment'
  | 'queueForPayment'
  | 'underProcessingForPayment';

export interface GetTransactionsParams {
  page: number;
  limit: number;
  orderBy?: TransactionOrderBy;
  status?: TransactionStatus;
  statuses?: TransactionStatus[];
  startDate?: string;
  isRefunded?: boolean;
  transactionType?: 'debit' | 'credit';
  tenantBuildingId?: string;
  searchQuery?: string;
}

export interface TenantTransactionTenantStats {
  totalRentPaid: number;
  saleTransactionCount: number;
  paidBuildingsCount: number;
}

export async function getTenantTransactionTenantStats(token: string | undefined) {
  if (!token) {
    throw new Error('Not authenticated');
  }
  try {
    const response = await axiosInstance.get<{
      message: string;
      data: TenantTransactionTenantStats;
    }>(GET_TENANT_TRANSACTION_TENANT_STATS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message?: string }>;
      if (axiosError.response?.data?.message) {
        throw new Error(`Error getting transaction stats: ${axiosError.response.data.message}`);
      }
      throw new Error(`Error getting transaction stats: ${axiosError.message}`);
    }
    const detail =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : (() => {
              try {
                return JSON.stringify(error) ?? String(error);
              } catch {
                return String(error);
              }
            })();
    throw new Error(`Error getting transaction stats: ${detail}`);
  }
}

const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    return (error as AxiosError<{ message?: string }>).response?.data?.message || error.message;
  }
  return error instanceof Error ? error.message : fallback;
};

export async function getPaymentRetryEligibility(
  token: string | undefined,
  tenantBuildingId: string
): Promise<boolean> {
  try {
    const response = await axiosInstance.get<{ data: { isEligible: boolean } }>(
      `${API_URL}/tenant-transaction/tenant-building/${tenantBuildingId}/retry-eligibility`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.data.isEligible;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Error checking payment retry eligibility'));
  }
}

export async function cancelPendingPaymentRetry(
  token: string | undefined,
  tenantBuildingId: string
): Promise<void> {
  try {
    await axiosInstance.post(
      `${API_URL}/payment-retries/tenant-building/${tenantBuildingId}/cancel`,
      undefined,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Error cancelling pending payment retry'));
  }
}

export async function getTransactions(token: string | undefined, params: GetTransactionsParams) {
  const {
    page,
    limit,
    orderBy = 'timestampAdded_DESC',
    status,
    statuses,
    startDate,
    isRefunded,
    transactionType,
    tenantBuildingId,
    searchQuery,
  } = params;

  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    orderBy,
    ...(startDate && { startDate }),
    ...(isRefunded !== undefined && { isRefunded: String(isRefunded) }),
    ...(transactionType && { transactionType }),
    ...(tenantBuildingId && { tenantBuildingId }),
    ...(searchQuery && { searchQuery }),
  });
  // `statuses[]` keeps a single value parsed as an array on the backend
  const requestedStatuses = statuses ?? (status ? [status] : []);
  requestedStatuses.forEach((value) => query.append('statuses[]', value));

  try {
    const response = await axiosInstance.get<transactionsResponse>(
      `${GET_TRANSACTIONS}?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<transactionsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting transactions: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting transactions: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting transactions: ${error}`);
    }
  }
}
export async function getIndustryMenu(token: string | undefined) {
  try {
    const response = await axiosInstance.get<kycIndustryResponse>(GET_INDUSTRY_MENU, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<transactionsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting KYC Industry: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting KYC Industry: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting KYC Industry: ${error}`);
    }
  }
}
export async function updateTenantPhone(
  token: string | undefined,
  request: { userDetails: { phoneNumber: string } }
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(UPDATE_TENANT_URL, request, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const message = axiosError.response.data.message;
        if (message === 'phone_number_blocked') {
          throw new Error('phone_number_blocked');
        }
        throw new Error(`Error updating tenant: ${message}`);
      } else {
        throw new Error(`Error updating tenant: ${error.message}`);
      }
    } else {
      throw new Error(`Error updating tenant: ${error}`);
    }
  }
}
export async function sendForgotPasswordEmail(baseUrlName: string, userName: string) {
  const requestBody: ForgotPasswordEmailRequest = {
    baseUrlName,
    userName,
    userType: 'tenantPortalUser',
  };

  try {
    const response = await axiosInstance.post<ApiResponse>(FORGOT_PASSWORD_EMAIL_URL, requestBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const message = axiosError?.response?.data?.message;
        if (message === 'user_type_not_authorized' || message === 'user_not_found') {
          return { message };
        }
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error sending reset link: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error sending reset link: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error sending reset link: ${error}`);
    }
  }
}
export async function verifyForgotPasswordEmail(hash: string | undefined, password: string) {
  const requestBody: VerifyPasswordEmailRequest = {
    payload: {
      hash: hash || '',
      password: password,
    },
  };
  try {
    const response = await axiosInstance.post<ApiResponse>(VERIFY_PASSWORD_EMAIL_URL, requestBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        if (axiosError.response.data.message === 'User does not exist') {
          return { message: 'User does not exist' };
        }
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error verifying password: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying password: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying password: ${error}`);
    }
  }
}
export async function payRent(token: string | undefined, tenantBuildingId: number) {
  try {
    const response = await axiosInstance.post<payRentResponse>(
      `${PAY_RENT}/${tenantBuildingId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<payRentResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error paying rent: ${axiosError.response.data}`);
      } else {
        throw new Error(`Error paying rent: ${error.message}`);
      }
    } else {
      throw new Error(`Error paying rent: ${error}`);
    }
  }
}

/* export async function subscribePayment(
  token: string | undefined,
  tenantBuildingId: number,
  rentTenure: number
): Promise<subscribeResponse | ApiResponse> {
  try {
    const response = await axiosInstance.post<subscribeResponse>(
      `${SUBSCRIBE_PAYMENT}/${tenantBuildingId}`,
      {
        includeRentForMonths: rentTenure,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        if (errorMessage === 'error_creating_plan') {
          throw { message: 'error_creating_plan' };
        } else {
          throw new Error(`Error subscribing payment: ${errorMessage}`);
        }
      } else {
        throw new Error(`Error subscribing payment: ${error.message}`);
      }
    } else {
      throw new Error(`Error subscribing payment: ${error}`);
    }
  }
} */
export async function updateBuilding(
  token: string | undefined,
  tenantBuildingId: string | undefined,
  requestBody:
    | UpdateBuildingRequest
    | rntUpdateRequest
    | managerUpdateRequest
    | rentAddressRequest
    | rentDetailsRequest
    | addressDetailsRequest
    | UpdateDueDateTypeRequest
    | UpdateLeaseDocument
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${UPDATE_BUILDING}/${tenantBuildingId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating building: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating building: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function updateBuildingStatus(
  token: string | undefined,
  tenantBuildingId: string,
  isActive: boolean
): Promise<ApiResponse> {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${UPDATE_BUILDING_STATUS}/${tenantBuildingId}/status`,
      { isActive },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to update building status. Please try again.')
      );
    }
    throw new Error('Unexpected error occurred while updating building status. Please try again.');
  }
}

export async function addBuildingManager(
  token: string | undefined,
  requestBody: AddBuildingManager
): Promise<ApiResponse | undefined> {
  try {
    const response = await axiosInstance.post<ApiResponse>(ADD_BUILDING_MANAGER_URL, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const serverMessage = error.response?.data?.message;
      console.error('API Error:', serverMessage || error.message);
      throw new Error(
        formatApiErrorMessage(serverMessage, 'Something went wrong while adding the property manager. Please try again.')
      );
    } else {
      console.error('Unexpected Error:', error);
      throw new Error('An unexpected error occurred. Please try again.');
    }
  }
}
export async function getCompanySettings() {
  try {
    const response = await axiosInstance.get<compnayResponse>(GET_COMPANY_SETTING);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        if (axiosError.response.data.message === 'invalid_domain') {
          return { message: 'invalid_domain' };
        }
        if (axiosError.response.data.message === 'subdomain_not_found') {
          return { message: 'subdomain_not_found' };
        }
        throw new Error(`Error fetching company settings: ${axiosError.response.data.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
}
export const uploadToS3 = async (
  file: File,
  uploadUrl: string,
  onProgress?: (percent: number) => void
) => {
  await axiosInstance.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    withCredentials: false,
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        onProgress(Math.round((event.loaded / event.total) * 100));
      }
    },
  });
};
export const getPresignedUrl = async (
  filename: string,
  fileType: string,
  token: string | undefined,
  destination: string
) => {
  const response = await axiosInstance.post(
    `${API_URL}/upload/preSignedUrl`,
    {
      filename,
      fileType,
      destination,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return {
    url: response.data.url,
    uploadUrl: response.data.uploadUrl,
    downloadUrl: response.data.downloadUrl,
  };
};
export const getBuildingsBySubdomain = async (
  token: string | undefined,
  limit?: number,
  searchQuery?: string
) => {
  try {
    const params: Record<string, number | string | undefined> = {};
    if (limit) params.limit = limit;
    if (searchQuery) params.searchQuery = searchQuery;
    const response = await axiosInstance.get<buildingsSubdomainResponse>(GET_BUILDINGS_SUBDOMAIN, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<buildingsSubdomainResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching buildings: ${axiosError.response.data.message}`);
      }
    }
    console.error('Unexpected error:', error);
    throw new Error('An unexpected error occurred while fetching buildings');
  }
};
export const getUnitsBySubdomain = async (
  token: string | undefined,
  buildingId: number,
  limit?: number,
  searchQuery?: string
) => {
  try {
    const params: Record<string, number | string | undefined> = {};
    if (limit) params.limit = limit;
    else params.limit = 50;
    if (searchQuery) params.searchQuery = searchQuery;
    params.buildingId = buildingId;
    const response = await axiosInstance.get<unitDetailsResponse>(GET_UNITS_SUBDOMAIN, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<unitDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching units of building: ${axiosError.response.data.message}`);
      }
    }
    console.error('Unexpected error:', error);
    throw new Error('An unexpected error occurred while fetching building units.');
  }
};
export async function createUnit(token: string | undefined, unitBody: UnitRequest) {
  try {
    const response = await axiosInstance.post<ApiResponse>(CREATE_UNIT, unitBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data.message === 'unit_number_already_exist') {
        throw new Error('unit_exist');
      }
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error creating new unit: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error creating new unit: ${error.message}`);
      }
    } else {
      throw new Error(`Error creating new unit: ${error}`);
    }
  }
}

export async function getBanks(token: string | undefined) {
  try {
    const response = await axiosInstance.get<BanksResponse>(GET_BANKS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching banks: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching banks: ${error.message}`);
      }
    } else {
      throw new Error(`Error fetching banks: ${error}`);
    }
  }
}

export async function createPaymentOption(
  token: string | undefined,
  paymentOptionBody: PaymentOptionRequest
) {
  try {
    const response = await axiosInstance.post<CreatePaymentOptionResponse>(
      CREATE_PAYMENT_OPTION,
      paymentOptionBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error creating payment option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error creating payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Error creating payment option: ${error}`);
    }
  }
}

export async function getPadTerms(token: string | undefined, name: string = 'authDirectPayment') {
  try {
    const response = await axiosInstance.get<PadTermsResponse>(GET_PAD_TERMS(name), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching PAD terms: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching PAD terms: ${error.message}`);
      }
    } else {
      throw new Error(`Error fetching PAD terms: ${error}`);
    }
  }
}

export async function createPlaidLink(token: string | undefined) {
  if (!token) {
    throw new Error('User is not authenticated');
  }

  try {
    const response = await axiosInstance.post<PlaidLinkResponse>(
      PLAID_LINK_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error creating plaid link: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error creating plaid link: ${error.message}`);
      }
    } else {
      throw new Error(`Error creating plaid link: ${error}`);
    }
  }
}

export async function plaidCallback(token: string | undefined, publicToken: string) {
  if (!token) {
    throw new Error('User is not authenticated');
  }

  try {
    const response = await axiosInstance.post<PlaidCallbackResponse>(
      PLAID_CALLBACK_API,
      { publicToken },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error in plaid callback: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error in plaid callback: ${error.message}`);
      }
    } else {
      throw new Error(`Error in plaid callback: ${error}`);
    }
  }
}

export async function generatePayNumber(token: string | undefined, request: payNumberRequest) {
  try {
    const response = await axiosInstance.post<payNumberResponse>(GENERATE_PAY_NUMBER, request, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error creating new unit: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error creating new unit: ${error.message}`);
      }
    } else {
      throw new Error(`Error creating new unit: ${error}`);
    }
  }
}
export async function checkSubdomainValid(
  setDomainStatus: React.Dispatch<React.SetStateAction<'valid' | 'invalid' | null>>
) {
  try {
    const response = await axiosInstance.get<subdomainResponse>(GET_SUBDOMAIN_STATUS);
    const { isValid, isReserved } = response.data.data;
    // Set domain status invalid if isReserved e.g 'staging-app'
    if (isValid && (isReserved === null || isReserved === false)) {
      setDomainStatus('valid');
    } else {
      setDomainStatus('invalid');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error(`Error getting subdomain status: ${axiosError.response.data.message}`);
      } else {
        console.error(`Error getting subdomain status: ${error.message}`);
      }
    } else {
      console.error(`Error getting subdomain status: ${error}`);
    }
    // Set domain status to invalid if an error occurs
    setDomainStatus('invalid');
  }
}
export async function checkResidentExists(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ResidentExistsResponse>(CHECK_RESIDENT_EXISTS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(axiosError.response.data.message || 'Error checking resident exists');
      }
      throw new Error(`Error checking resident exists: ${error.message}`);
    }
    throw new Error(`Error checking resident exists: ${error}`);
  }
}

export async function getDetailsByPayNumber(token: string | undefined, payNumber: string) {
  try {
    const response = await axiosInstance.get<PayNumberDetailsResponse>(
      GET_DETAILS_BY_PAY_NUMBER(payNumber),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(axiosError.response.data.message || 'Error fetching pay number details');
      }
      throw new Error(`Error fetching pay number details: ${error.message}`);
    }
    throw new Error(`Error fetching pay number details: ${error}`);
  }
}

export async function checkPayNumber(token: string | undefined, payNumber: string) {
  try {
    const response = await axiosInstance.get<payNumberResponse>(
      `${VALIDATE_PAY_NUMBER}?payNumber=${payNumber}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<tenantDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;

        // Handle "pay_number_not_found" error
        if (errorMessage === 'pay_number_not_found') {
          console.error('Pay number not found:', errorMessage);
          throw new Error('pay_number_not_found');
        }
        if (errorMessage === 'pay_number_does_not_belong_to_the_company') {
          console.error('Pay number does not belong to company:', errorMessage);
          throw new Error('pay_number_does_not_belong_to_the_company');
        }
        if (PAY_NUMBER_INACTIVE_REASONS.some((reason) => reason === errorMessage)) {
          throw new Error(errorMessage);
        }
        // Handle other errors
        console.error('Error validating pay number:', errorMessage);
        throw new Error(`Error validating pay number: ${errorMessage}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error validating pay number: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error validating pay number: ${error}`);
    }
  }
}
export async function ResetPassword(token: string | undefined, requestBody: ResetPasswordRequest) {
  try {
    const response = await axiosInstance.post<ResetPasswordResponse>(
      LOGIN_RESET_PASSWORD,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error resetting password:', error);
  }
}

export interface NuveiRedirectUrlsRequest {
  redirectUrl?: string;
  cancelUrl?: string;
}

// Unified function for opening orders with direct payment API
export async function directPaymentToken(
  token: string | undefined,
  tenantBuildingId: string,
  tenantPaymentOptionId: string,
  redirectUrls?: NuveiRedirectUrlsRequest
) {
  if (!tenantBuildingId || !tenantPaymentOptionId) {
    throw new Error('tenantBuildingId and tenantPaymentOptionId are required');
  }
  try {
    const response = await axiosInstance.post<OpenOrderResponse>(
      DIRECT_PAYMENT_TOKEN_API,
      {
        tenantBuildingId,
        tenantPaymentOptionId,
        ...redirectUrls,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<OpenOrderResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error opening order: ${axiosError.response.data.reason || axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error opening order: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error opening order: ${error}`);
    }
  }
}

export async function authPaymentToken(
  token: string | undefined,
  paymentMethod: PaymentMethodType,
  redirectUrls?: NuveiRedirectUrlsRequest
) {
  try {
    const response = await axiosInstance.post<OpenOrderResponse>(
      AUTH_PAYMENT_TOKEN_API,
      { paymentMethod, ...redirectUrls },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<OpenOrderResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error opening order: ${axiosError.response.data.reason || axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error opening order: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error opening order: ${error}`);
    }
  }
}

export async function authPayment(token: string | undefined, tenantPaymentOptionId: string) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      AUTH_PAYMENT,
      { tenantPaymentOptionId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error auth payment: ${axiosError.response.data.message || axiosError.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error auth payment: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error auth payment: ${error}`);
    }
  }
}

export async function getPaymentOptions(token: string | undefined): Promise<PaymentOption[]> {
  try {
    const response = await axiosInstance.get<PaymentOption[]>(`${GET_PAYMENT_OPTIONS}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<PaymentOption[]>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error fetching payment options: ${axiosError.response.data}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error fetching payment options: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error fetching payment options: ${error}`);
    }
  }
}

export async function getBuildingDetailsById(
  token: string | undefined,
  tenantBuildingId?: string // Optional as per the API
) {
  try {
    const response = await axiosInstance.get<buildingDetailsResponse>(
      GET_BUILDING_BY_ID, // Your base API endpoint
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tenantBuildingId, // Send tenantBuildingId as a query parameter
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<buildingDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting building details: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting building details: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting building details: ${error}`);
    }
  }
}

export async function updateCardDetails(
  token: string | undefined,
  paymentOptionId: string | undefined,
  requestBody: UpdateCardRequestBody
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${UPDATE_CARD_DETAILS}/${paymentOptionId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating payment option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function deleteCard(
  token: string | undefined,
  tenantPaymentOptionId: string | undefined
) {
  try {
    const response = await axiosInstance.delete<ApiResponse>(
      `${REMOVE_CARD}/${tenantPaymentOptionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error deleting payment option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error deleting payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
/**
 * @deprecated This function is deprecated and should not be used.
 */
export async function getTransactionsStatus(tenantBuildingId: string, token: string | undefined) {
  try {
    const response = await axiosInstance.get<TransactionsStatusResponse>(
      getTransactionStatusUrl(tenantBuildingId),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<TransactionsStatusResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error fetching transaction status: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error fetching transaction status: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error fetching transaction status: ${error}`);
    }
  }
}

export async function getPaymentSummary(
  token: string | undefined,
  tenantBuildingId: string | undefined,
  tenantPaymentOptionId: string | undefined,
  paymentMethod: PaymentMethodType = PaymentMethodType.CreditCard // Default to 'Credit Card'
) {
  try {
    const response = await axiosInstance.get<PaymentSummaryResponse>(
      `${API_URL}/payment/tenant/rent/${tenantBuildingId}/summary`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantPaymentOptionId,
          paymentMethod,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<PaymentSummaryResponse>;
      if (axiosError.response && axiosError.response.data) {
        if (axiosError.response.data.message === 'subscription_period_too_short') {
          return;
        }
        throw new Error(
          `Error getting payment option summary : ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error getting payment option Summary: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
/* export async function createSubscription(
  token: string | undefined,
  tenantBuildingId: string | undefined,
  tenantPaymentOptionId: string
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${SUBSCRIBE}/${tenantBuildingId}`,
      { tenantPaymentOptionId: tenantPaymentOptionId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error creating subscription: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error creating subscription: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error creating subscription: ${error}`);
    }
  }
} */

/* export async function getSubscriptionDetails(
  token: string | undefined,
  tenantBuildingId: string | undefined
) {
  try {
    const response = await axiosInstance.get<SubscriptionDetailResponse>(
      `${SUBSCRIPTION}/${tenantBuildingId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantBuildingId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error getting subscription summary : ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error getting subscription Summary: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
 */
/* export async function cancelSubscription(
  token: string | undefined,
  tenantBuildingId: string | undefined
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${SUBSCRIBE}/${tenantBuildingId}/cancel`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tenantBuildingId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating subscription: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating subscription: ${error.message}`);
      }
    } else {
      throw new Error(`Error updating subscription: ${error}`);
    }
  }
} */

export async function getSubscriptionSummaryForBuilding(
  token: string | undefined,
  tenantBuildingId: string | undefined,
  rentAmount: number | null,
  dueDate: number | undefined,
  leaseStartDate: string | undefined,
  leaseEndDate: string | undefined
) {
  try {
    const response = await axiosInstance.get<SubscriptionDetailResponse>(
      `${PAY_RENT}/${tenantBuildingId}/summary/subscription/calculate`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantBuildingId,
          rentAmount,
          dueDate,
          leaseStartDate,
          leaseEndDate,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      throw new Error(`${axiosError?.response?.data.message}`);
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function initiateMFA(token: string | undefined) {
  try {
    const response = await axiosInstance.post<InitiateMFAResponse>(
      INITIATE_MFA,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<InitiateMFAResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        switch (errorMessage) {
          case 'mfa_not_required':
            throw new Error('MFA is not required');
          case 'mfa_not_enabled_from_backend':
            throw new Error('MFA is not enabled globally');
          default:
            throw new Error(`Error initiating MFA: ${errorMessage}`);
        }
      } else {
        throw new Error('Server error initiating MFA. Try again later.');
      }
    } else {
      throw new Error('Network error initiating MFA. Check your connection.');
    }
  }
}
export async function initiateMFAEmail(token: string | undefined) {
  try {
    const response = await axiosInstance.post<InitiateMFAResponse>(
      INITIATE_MFA_EMAIL,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<InitiateMFAResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        switch (errorMessage) {
          case 'mfa_not_required':
            throw new Error('MFA is not required');
          case 'mfa_not_enabled_from_backend':
            throw new Error('MFA is not enabled globally');
          default:
            throw new Error(`Error initiating MFA: ${errorMessage}`);
        }
      } else {
        throw new Error('Server error initiating MFA. Try again later.');
      }
    } else {
      throw new Error('Network error initiating MFA. Check your connection.');
    }
  }
}
export async function verifyMFA(token: string, code: string) {
  try {
    const response = await axiosInstance.post<mfaResponse>(
      VERIFY_MFA,
      {
        verificationCode: code,
        digit: 4,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          Origin: APP_ENV,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { message, errorMessage } = axiosError.response.data;
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error verifying code: ${message} ${errorMessage}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying code: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
}
export async function verifyMFAEmail(token: string, code: string) {
  try {
    const response = await axiosInstance.post<mfaResponse>(
      VERIFY_MFA_EMAIL,
      {
        verificationCode: code,
        digit: 4,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          Origin: APP_ENV,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { message, errorMessage } = axiosError.response.data;
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error verifying code: ${message} ${errorMessage}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error verifying code: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error verifying code: ${error}`);
    }
  }
}
export async function createLoginToken(token: string) {
  try {
    const response = await axiosInstance.post<mfaResponse>(
      CREATE_JWT,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const { message, errorMessage } = axiosError.response.data;
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error creating JWT token: ${message} ${errorMessage}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error creating JWT token: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error creating JWT token: ${error}`);
    }
  }
}
export async function checkMFAStatus(token: string) {
  try {
    const response = await axiosInstance.get<mfaCookieResponse>(GET_MFA_STATUS, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching MFA status');
  }
}
export async function getTermsContent() {
  try {
    const response = await axiosInstance.get<termsResponse>(GET_TERMS_CONTENT);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.status === 404) {
        throw new Error('Terms content not found');
      } else {
        console.error('Error fetching terms content:', error.message);
      }
    } else {
      console.error('Unexpected error:', error);
    }
  }
}

export async function setUserConsent(requestBody: termsRequest, token: string) {
  try {
    const response = await axiosInstance.post<ApiResponse>(SET_USER_CONSENT, requestBody, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error setting user consent:', error);
  }
}
export async function checkUserConsent(token: string) {
  try {
    const response = await axiosInstance.get<checkConsentResponse>(CHECK_CONSENT, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user consent status');
  }
}

export async function getProcessingFeeDetails(token: string | undefined) {
  try {
    const response = await axiosInstance.get<processingFeeDetailsResponse>(
      GET_PROCESSING_FEE_DETAILS,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<processingFeeDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error getting processing fee details: ${axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting processing fee details: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting processing fee details: ${error}`);
    }
  }
}
export async function getListMFAEnabled(token: string) {
  try {
    const response = await axiosInstance.get<mfaListResponse>(GET_MFA_ENABLED_LIST, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching MFA for a user');
  }
}
export async function removeMFA(token: string, mfaId: string) {
  try {
    const response = await axiosInstance.delete<removeMFAResponse>(`${REMOVE_MFA}/${mfaId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error removing MFA for a user', error);
    throw error;
  }
}
export async function addMFAMethod(token: string, origin: string, type: string) {
  const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  console.log(navigator.userAgent);
  try {
    const response = await axiosInstance.post<addMFAResponse>(
      `${ADD_MFA}`,
      {
        isMobileDevice,
        name: type,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        params: { origin },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding MFA for a user', error);
    throw error;
  }
}
export async function initiateCryptoSession(
  token: string | undefined,
  tenantBuildingId: string | null | undefined | number
) {
  try {
    const response = await axiosInstance.post<initiateCryptoSessionResponse>(
      `${ALT5}/initSession/${tenantBuildingId}`,
      { tenantBuildingId },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching crypto session token', error);
    throw error;
  }
}
export async function markIDVApplicationSubmitted(token: string | undefined, tenantIdvId: string) {
  try {
    const response = await axiosInstance.patch<markIDVApplicationResponse>(
      `${IDV_APPLICATION}/${tenantIdvId}/submit`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting IDV application:', error);
    throw error;
  }
}

export const oAuth = async (sessionToken: string | undefined, referralCode: string | undefined) => {
  if (!sessionToken) {
    return;
  }
  const { utm } = getStoredUTMParams();
  try {
    const response = await axiosInstance.post<BaseResponse<OAuthResponse>>(OAUTH_URL, {
      sessionToken,
      referralCode: referralCode || undefined,
      utm: isNotEmptyObject(utm) ? utm : undefined,
    });
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message;
    if (message === 'error_in_oauth') {
      throw new Error('Something went wrong while logging in with social account.');
    }
    if (message === 'user_is_inactive') {
      throw new Error(
        'Your account has been locked. For assistance, please reach out to TenantPay support at support@tenantpay.com.'
      );
    }
    if (message === 'tenant_not_found') {
      throw new Error(
        'This email is already registered with another account. Please use a different email.'
      );
    }
    if (message === 'email_not_provided_by_descope') {
      throw new Error('Permission denied for email access. Try another social login method.');
    }
    if (message === 'phone_number_blocked') {
      throw new Error('phone_number_blocked');
    }
    handleApiError(error);
  }
};

export async function subscribePushNotification(
  token: string | undefined,
  body: { clientType: 'web' | 'android' | 'ios'; token: string }
) {
  try {
    const response = await axiosInstance.post<{ message: string }>(
      PUSH_NOTIFICATIONS_URL,
      {
        clientType: body.clientType,
        token: body.token,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error subscribing push notification: ${axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error subscribing push notification: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error subscribing push notification: ${error}`);
    }
  }
}

export async function getNotifications(token: string | undefined, page: number, limit: number) {
  try {
    const response = await axiosInstance.get<NotificationResponse>(NOTIFICATION_URL, {
      params: { page: page, limit: limit },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting notifications: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting notification: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting notification: ${error}`);
    }
  }
}

export async function getUnreadNotificationCount(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{ count: number }>(`${NOTIFICATION_URL}/unreadCount`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting notifications: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting notification: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting notification: ${error}`);
    }
  }
}

export async function getSeenNotificationCount(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{ count: number }>(`${NOTIFICATION_URL}/seenCount`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting notifications: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting notification: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting notification: ${error}`);
    }
  }
}

export async function markAllNotificationsAsRead(token: string | undefined) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${NOTIFICATION_URL}/viewAll`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error marking all  Notifications as read: ${axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error  marking all  Notifications as read: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error  marking all  Notifications as read: ${error}`);
    }
  }
}

export async function markAllNotificationsAsSeen(token: string | undefined) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${NOTIFICATION_URL}/seen`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error marking all  Notifications as seen: ${axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error  marking all  Notifications as seen: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error  marking all  Notifications as seen: ${error}`);
    }
  }
}
export async function markNotificationAsReadById(
  token: string | undefined,
  notificationId: string
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${NOTIFICATION_URL}/view/${notificationId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(
          `Error marking  Notifications as Read: ${axiosError.response.data.message}`
        );
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error  marking   Notifications as Read: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error  marking Notifications as Read: ${error}`);
    }
  }
}

export async function getNotificationTypes(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{ notificationTypeId: string; name: string }>(
      `${NOTIFICATION_URL}/types`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting notifications types: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting notification types: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting notification: ${error}`);
    }
  }
}
/* export async function getSubscriptionDetailsById(
  token: string | undefined,
  tenantSubscriptionId: string | undefined
) {
  try {
    const response = await axiosInstance.get<SubscriptionDetailResponse>(
      `${SUBSCRIPTION}/byId/${tenantSubscriptionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantSubscriptionId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error getting subscription summary : ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error getting subscription Summary: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
} */
export async function cancelTenantTransaction(
  token: string | undefined,
  tenantTransactionId: string | undefined
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${TENANT_TRANSACTIONS}/${tenantTransactionId}/cancel`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data?.message) {
        throw new Error(axiosError.response.data.message);
      }
      throw new Error(`Error cancelling transaction: ${error.message}`);
    }
    throw new Error(`Error cancelling transaction: ${error}`);
  }
}

export async function getTenantTransactionById(
  token: string | undefined,
  tenantTransactionId: string | undefined
) {
  try {
    const response = await axiosInstance.get<Transactions>(
      `${TENANT_TRANSACTIONS}/${tenantTransactionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantTransactionId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error getting subscription summary : ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error getting subscription Summary: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getActiveCreditBuildings(token: string | undefined) {
  try {
    const response = await axiosInstance.get<activeBuildingsList>(`${ACTIVE_BUILDINGS}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(
          `Error getting active buildings for credit reporting: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error getting active buildings for credit reporting: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function activateCreditBuilder(
  token: string | undefined,
  tenantBuildingId: string,
  body: activateCreditBuilderBody
) {
  try {
    const response = await axiosInstance.post<activateCreditBuilderResponse>(
      `${SUBSCRIBE_CREDIT_BUILDER}/${tenantBuildingId}/subscribe`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to activate Credit Builder reporting. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}
export async function getCreditBuilderDetails(token: string | undefined, tenantBuildingId: string) {
  try {
    const response = await axiosInstance.get<CreditBuilderDetails>(
      `${SUBSCRIBE_CREDIT_BUILDER}/${tenantBuildingId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to fetch Credit Builder details. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}
export async function unsubscribeMailer(token: string | undefined) {
  if (!token) {
    throw new Error('Missing unsubscribe token');
  }

  try {
    const response = await axiosInstance.get<UnsubscribeMail>(`${UNSUBSCRIBE_MAIL}/${token}`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message?: string }>;

      if (axiosError.response?.data?.message) {
        throw new Error(`Error unsubscribing from emails: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error unsubscribing from emails: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function unsubscribeByCategories(token: string, categories: string[]): Promise<void> {
  try {
    await axiosInstance.post(
      MAILER_UNSUBSCRIBE_URL,
      { emailCategories: categories },
      { headers: { 'x-token': token } },
    );
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message?: string }>;
      const msg = axiosError.response?.data?.message ?? axiosError.message;
      throw new Error(`Error updating email preferences: ${msg}`);
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function unsubscribeCreditBuilder(
  token: string | undefined,
  tenantBuildingId: string
) {
  try {
    const response = await axiosInstance.post<activateCreditBuilderResponse>(
      `${SUBSCRIBE_CREDIT_BUILDER}/${tenantBuildingId}/unsubscribe`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to cancel Credit Builder reporting. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}
export async function getUserPoints(token: string | undefined) {
  try {
    const response = await axiosInstance.get<userPointsResponse>(`${GET_USER_POINTS}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

/** Returns ISO date string when subscribed, otherwise null */
export async function getNewsletterSubscription(token: string | undefined): Promise<string | null> {
  if (!token) return null;
  try {
    const response = await axiosInstance.get<NewsletterSubscriptionApiResponse>(NEWSLETTERS_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    const raw = response.data.data?.subscribedOn;
    if (raw == null || raw === '') return null;
    return raw;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<MessageInterface>;
      if (axiosError.response?.data?.message) {
        throw new Error(axiosError.response.data.message);
      }
      throw new Error(`Error fetching newsletter status: ${error.message}`);
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function subscribeToNewsletter(token: string | undefined): Promise<MessageInterface> {
  if (!token) throw new Error('Not authenticated');
  try {
    const response = await axiosInstance.post<MessageInterface>(
      NEWSLETTERS_URL,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<MessageInterface>;
      if (axiosError.response?.data?.message) {
        throw new Error(axiosError.response.data.message);
      }
      throw new Error(`Error subscribing to newsletter: ${error.message}`);
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}
export async function getOffers(token: string | undefined) {
  try {
    const response = await axiosInstance.get<BaseResponse<GetOffersResponse>>(POINT_TASKS, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response?.data?.data?.tasks ?? [];
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getPointTasks(token: string | undefined, pointCategoryName?: string) {
  try {
    const response = await axiosInstance.get<{ data: OfferApiLike[] }>(POINT_TASKS, {
      params: pointCategoryName ? { pointCategoryName } : undefined,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data.data.map(normalizeOffer);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching point tasks for user: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching point tasks for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

type OfferApiLike = Partial<Offer> & {
  hasProgress?: boolean | number | string | null;
  showOnlyStarted?: boolean | number | string | null;
  isDynamic?: boolean | number | string | null;
  isCompleted?: boolean | number | string | null;
  completedCount?: number | string | null;
  minTickets?: number | string | null;
  maxTickets?: number | string | null;
  minPoints?: number | string | null;
  maxPoints?: number | string | null;
  maxCountPerUser?: number | string | null;
  threshold?: number | string | null;
  progress?: {
    completedCount?: number | string | null;
    totalCount?: number | string | null;
  } | null;
};

function normalizeOffer(t: OfferApiLike): Offer {
  return {
    ...(t as Offer),
    hasProgress:
      typeof t?.hasProgress === 'boolean' ? t.hasProgress : Number(t?.hasProgress ?? 0) === 1,
    showOnlyStarted:
      typeof t?.showOnlyStarted === 'boolean'
        ? t.showOnlyStarted
        : Number(t?.showOnlyStarted ?? 0) === 1,
    isDynamic: typeof t?.isDynamic === 'boolean' ? t.isDynamic : Number(t?.isDynamic ?? 0) === 1,
    isCompleted:
      typeof t?.isCompleted === 'boolean'
        ? t.isCompleted
        : String(t?.isCompleted ?? '').toLowerCase() === 'true',
    completedCount: Number(t?.completedCount ?? 0),
    minTickets: Number(t?.minTickets ?? 0),
    maxTickets: Number(t?.maxTickets ?? 0),
    minPoints: Number(t?.minPoints ?? 0),
    maxPoints: Number(t?.maxPoints ?? 0),
    maxCountPerUser:
      t?.maxCountPerUser === null || t?.maxCountPerUser === undefined
        ? null
        : Number(t.maxCountPerUser),
    threshold: t?.threshold === null || t?.threshold === undefined ? null : Number(t.threshold),
    progress:
      t?.progress && typeof t.progress === 'object'
        ? {
            completedCount: Number(t.progress.completedCount ?? 0),
            totalCount: Number(t.progress.totalCount ?? 0),
          }
        : null,
  } satisfies Offer;
}

export async function getPointTasksWithProgressAndStats(
  token: string | undefined,
  pointCategoryName?: string
) {
  try {
    const response = await axiosInstance.get<{ data: OfferApiLike[] }>(POINT_TASKS, {
      params: pointCategoryName ? { pointCategoryName } : undefined,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const tasks = response.data.data.map(normalizeOffer);

    const byCategory = tasks.reduce<Partial<Record<PointCategoryName, Offer[]>>>((acc, t) => {
      const name = t.pointCategoryName;
      if (!name) return acc;
      acc[name] = acc[name] ?? [];
      acc[name].push(t);
      return acc;
    }, {});

    const categories = (
      Object.entries(byCategory) as Array<[PointCategoryName, Offer[] | undefined]>
    ).map(([name, ts]) => {
      const safeTs = ts ?? [];
      const totalTasks = safeTs.length;
      const totalCompleted = safeTs.filter((item) => item.isCompleted).length;
      const pointCategoryId = String(
        safeTs.find((item) => item.pointCategoryId != null)?.pointCategoryId ?? ''
      );
      return {
        pointCategoryId,
        pointCategoryName: name,
        totalTasks,
        totalCompleted,
      };
    });

    const totalTasks = tasks.length;
    const totalCompleted = tasks.filter((t) => t.isCompleted).length;

    return {
      tasks,
      stats: {
        totalTasks,
        totalCompleted,
        categories,
      },
    } satisfies GetOffersResponse;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching point tasks for user: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching point tasks for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getPointTasksStats(token: string | undefined, pointCategoryName?: string) {
  try {
    const response = await axiosInstance.get<PointTasksStatsApiResponse>(`${POINT_TASKS}/stats`, {
      params: pointCategoryName ? { pointCategoryName } : undefined,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data.data satisfies PointTasksStats;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching point task stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching point task stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getContestTime(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ContestTimeResponse>(CONTEST_TIME_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching contest time: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching contest time: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getContestStats(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ContestStatsResponse>(CONTEST_STATS_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching contest stats: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching contest stats: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getContestWinnerStatus(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ContestWinnerStatusResponse>(CONTEST_STATUS_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching contest status: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching contest status: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}


export async function getContestPrizes(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ContestPrizeListResponse>(CONTEST_PRIZES_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching contest rent drops: ${axiosError.response.data.message}`);
      }
      throw new Error(`Error fetching contest rent drops: ${error.message}`);
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function getContestLeaderboard(
  token: string | undefined,
  opts?: { limit?: number; includeOnlyLatestContest?: boolean }
) {
  const limit = opts?.limit ?? 10;
  const includeOnlyLatestContest = opts?.includeOnlyLatestContest ?? true;

  try {
    const response = await axiosInstance.get<ContestLeaderboardResponse>(CONTEST_LEADERBOARD_URL, {
      params: {
        limit,
        includeOnlyLatestContest,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching contest leaderboard: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching contest leaderboard: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getPointRank(token: string | undefined): Promise<{ userRank: number; topRankTicketCount: number }> {
  try {
    const response = await axiosInstance.get<{ userRank: number; topRankTicketCount: number }>(
      POINT_RANK_URL,
      { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message: string }>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching point rank: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching point rank: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getReferralLink(token: string | undefined) {
  try {
    const response = await axiosInstance.get(`${GET_REFERRAL_LINK}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching referral code for the user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching referral code for the user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function sendReferralCode(token: string | undefined, email: string) {
  try {
    const response = await axiosInstance.post<sendReferralCodeInterface>(
      `${SEND_REFERRAL_CODE}`,
      { email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error sending referral code to the user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error sending referral code to the user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function validateReferralCode(referralCode: string) {
  try {
    const response = await axiosInstance.post<{ result: string }>(
      `${VALIDATE_REFERRAL_CODE}/${referralCode}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error validating referral code for the user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error validating referral code for the user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getRewardsHistory(token: string | undefined) {
  try {
    const response = await axiosInstance.get<RewardsHistoryResponse>(
      `${GET_USER_POINTS}/transactions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getGiftCards(
  token: string | undefined,
  page: number,
  limit: number,
  search: string
) {
  try {
    // The query string is part of the URL (not `params`) so retries resend the identical URL
    const query = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
    });
    const response = await axiosInstance.get<GetGiftBitBrandsResponse>(
      `${GIFTBIT}/brands?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching gift cards: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching gift cards: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getGiftCardsDetails(token: string | undefined, brandCode: string) {
  try {
    const response = await axiosInstance.get<GiftCardsDetailsResponse>(
      `${GIFTBIT}/brands/${brandCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching gift card details: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching gift card details: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function convertAmountsToPoints(
  token: string | undefined,
  amounts: number[],
  from: string
) {
  const requestBody = {
    data: amounts.map((amount) => ({
      amount: amount.toFixed(2),
      from: from,
    })),
  };
  try {
    const response = await axiosInstance.post<convertAmountPoints>(
      `${GET_USER_POINTS}/convert/toPoints`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error converting amount to points: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error converting amount to points: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function redeemGiftCardRequest(
  token: string,
  brandCode: string,
  amountInDollars: number
) {
  try {
    const response = await axiosInstance.post<sendGiftCardResponse>(
      `${GIFTBIT}/redeem`,
      {
        brandCode,
        amountInDollars,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        const { message } = axiosError.response.data;
        if (
          message === 'no_successful_payment_found' ||
          message === 'tenant_identity_not_verified' ||
          message === 'email_not_verified'
        ) {
          throw new Error(message);
        }
        throw new Error(`Error sending gift card: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error sending gift card: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function updateCardBrandDetails(
  token: string | undefined,
  paymentOptionId: string | undefined,
  cardBrandType: string
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${UPDATE_CARD_DETAILS}/${paymentOptionId}/cardBrandType`,
      { cardBrandType: cardBrandType },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating payment option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getReferralList(
  token: string | undefined,
  params?: { page?: number; limit?: number }
) {
  try {
    const response = await axiosInstance.get<referralListResponse>(
      `${GET_REFERRAL_LIST}`,

      {
        params: {
          page: params?.page,
          limit: params?.limit,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    console.log('Referral List Response:', response.data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating payment option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getSocialSubmissions(
  token: string | undefined,
  params?: { page?: number; limit?: number }
): Promise<SocialSubmissionListResponse> {
  try {
    const response = await axiosInstance.get<SocialSubmissionListResponse>(SOCIAL_SUBMISSIONS_URL, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<MessageInterface>;
      throw new Error(
        formatApiErrorMessage(
          axiosError.response?.data?.message,
          'Could not load your social submissions. Please try again.'
        )
      );
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function createSocialSubmission(
  token: string | undefined,
  body: CreateSocialSubmissionRequest
): Promise<MessageInterface> {
  try {
    const response = await axiosInstance.post<MessageInterface>(SOCIAL_SUBMISSIONS_URL, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<MessageInterface>;
      throw new Error(
        formatApiErrorMessage(
          axiosError.response?.data?.message,
          'Could not submit your entry. Please try again.'
        )
      );
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function updateSocialSubmission(
  token: string | undefined,
  socialSubmissionId: string,
  body: UpdateSocialSubmissionRequest
): Promise<MessageInterface> {
  try {
    const response = await axiosInstance.patch<MessageInterface>(
      `${SOCIAL_SUBMISSIONS_URL}/${encodeURIComponent(socialSubmissionId)}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<MessageInterface>;
      throw new Error(
        formatApiErrorMessage(
          axiosError.response?.data?.message,
          'Could not update your submission. Please try again.'
        )
      );
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export async function getRentCreditOptions(token: string | undefined) {
  try {
    const response = await axiosInstance.get<RentCreditOption[]>(
      `${GET_USER_POINTS}/rentCreditOptions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching rent credit options: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching rent credit options: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getEquifaxCreditHealthUrl(token: string | undefined, type: string) {
  try {
    const response = await axiosInstance.post<EquifaxCreditHealthUrlResponse>(
      `${EQUIFAX_CREDIT_HEALTH}`,
      { type },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<EquifaxCreditHealthUrlResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching Equifax credit health URL: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getRentCredit(token: string | undefined) {
  try {
    const response = await axiosInstance.get<rentCreditResponse>(`${RENT_CREDIT}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error fetching rent credit: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching rent credit: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function redeemRentCredit(token: string | undefined, rentCreditOptionId: string) {
  try {
    const response = await axiosInstance.post<redeemRentCreditResponse>(
      `${SAVE_RENT_CREDIT}`,
      {
        rentCreditOptionId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error redeeming rent credit option: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error redeeming rent credit option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getEVoucherAmount(token: string | undefined, code: string) {
  try {
    const response = await axiosInstance.get<{ data: { amount: number } }>(E_VOUCHERS, {
      params: { code },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.amount;
  } catch (error) {
    throw new Error(getEVoucherErrorCode(error));
  }
}

export async function redeemEVoucher(token: string | undefined, code: string) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      E_VOUCHERS,
      { code },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    throw new Error(getEVoucherErrorCode(error));
  }
}

function getEVoucherErrorCode(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiResponse>;
    return axiosError.response?.data?.message ?? error.message;
  }
  return String(error);
}
export async function getTenantProfileProgress(token: string) {
  try {
    const response = await axiosInstance.get<tenantProgressRespone>(GET_TENANT_PROGRESS, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching tenant progress: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching tenant progress: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function updatePaymentOption(
  token: string | undefined,
  tenantPaymentOptionId: string | undefined,
  requestBody: {
    billingInfo: {
      countryCode: string;
      fullAddress: string;
      postalCode: string;
      provinceCode?: string;
      city: string;
    };
    isDefault: boolean;
  }
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${UPDATE_PAYMENT_OPTION}/${tenantPaymentOptionId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating building: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating building: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function verifyPaymentOption(
  token: string | undefined,
  paymentOptionId: string,
  amount: number
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      VERIFY_PAYMENT_OPTION(paymentOptionId),
      { amount },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const apiMessage = axiosError.response.data.message;

        const verificationErrorMessages: Record<string, string> = {
          tenant_payment_option_verification_amount_mismatch:
            'The verification amount you entered does not match. Please check your bank statement and try again.',
          tenant_payment_option_verification_expired:
            'Your verification period has expired. Please remove this payment method and add it again to restart verification.',
          tenant_payment_option_verification_attempts_exceeded:
            'You have exceeded the maximum number of verification attempts. Please remove this payment method and add it again.',
          tenant_payment_option_verification_failed:
            'This payment method has failed verification and can no longer be verified. Please remove it and add a new one.',
          tenant_payment_option_verification_not_found:
            'No pending verification was found for this payment method. Please contact support if this issue persists.',
          payment_option_not_found:
            'Payment method not found. Please refresh the page and try again.',
        };

        if (typeof apiMessage === 'string') {
          for (const [code, message] of Object.entries(verificationErrorMessages)) {
            if (apiMessage.includes(code)) {
              throw new Error(message);
            }
          }
        }

        throw new Error(
          `Error verifying payment option: ${apiMessage || 'Unable to verify payment method. Please try again.'}`
        );
      } else {
        throw new Error(`Error verifying payment option: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getFAQs(token: string | undefined, category: string) {
  try {
    const response = await axiosInstance.get<FAQResponse[]>(`${GET_FAQ}/${category}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching tenant progress: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching tenant progress: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getTransactionTimeline(
  token: string | undefined,
  tenantTransactionId: string | null
) {
  try {
    const response = await axiosInstance.get<TransactionTimelineResponse>(
      `${GET_TRANSACTION_TIMELINE}/${tenantTransactionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching transaction timeline: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching transaction timeline: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

const EXPECTED_PAYMENT_SEND_DATE_CACHE_TTL_MS = 5 * 60 * 1000;
const expectedPaymentSendDateCache = new Map<string, { value: string | null; fetchedAt: number }>();

/**
 * Expected date the payment is sent to the landlord (YYYY-MM-DD), or null when unknown.
 * Cached per transaction and never throws, so a failure just leaves the date unknown.
 */
export async function getExpectedPaymentSendDate(
  token: string | undefined,
  tenantTransactionId: string
): Promise<string | null> {
  const cached = expectedPaymentSendDateCache.get(tenantTransactionId);
  if (cached && Date.now() - cached.fetchedAt < EXPECTED_PAYMENT_SEND_DATE_CACHE_TTL_MS) {
    return cached.value;
  }
  try {
    // This endpoint returns the transaction object directly (no `data` envelope).
    const response = await axiosInstance.get<{ expectedPaymentSendDate: string | null }>(
      `${API_URL}/tenant-transaction/${tenantTransactionId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const date = response.data.expectedPaymentSendDate ?? null;
    expectedPaymentSendDateCache.set(tenantTransactionId, { value: date, fetchedAt: Date.now() });
    return date;
  } catch (error) {
    console.error('Error fetching expected payment send date', error);
    return null;
  }
}

export async function subscribeRent(
  token: string | undefined,
  tenantBuildingId: string,
  tenantPaymentOptionId: string
) {
  if (!tenantBuildingId) {
    throw new Error('tenantBuildingId is required');
  }
  try {
    const requestBody: {
      tenantBuildingId: string;
      tenantPaymentOptionId: string;
    } = {
      tenantBuildingId,
      tenantPaymentOptionId,
    };

    const response = await axiosInstance.post<redeemRentCreditResponse>(
      `${TENANT_SUBSCRIPTION}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to set up Autopay. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}

export async function cancelRentSubscription(
  token: string | undefined,
  tenantMitSubscriptionId: string | undefined
) {
  try {
    const response = await axiosInstance.post<redeemRentCreditResponse>(
      `${TENANT_SUBSCRIPTION}/${tenantMitSubscriptionId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error subscribing to Rent: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error subscribing to Rent: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function saveUserIpAddress(token: string | undefined, ipAddress: string) {
  try {
    const response = await axiosInstance.post<BaseResponse<null>>(
      SAVE_USER_IP_ADDRESS,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'x-ip-address': ipAddress,
        },
      }
    );
    return response.data;
  } catch (error) {
    // Log error to Sentry for IP address API
    logThirdPartyError(new Error('Error saving user IP address'), {
      api: 'saveUserIpAddress',
      endpoint: SAVE_USER_IP_ADDRESS,
      error: error instanceof Error ? error.message : String(error),
    });

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error saving IP address: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error saving IP address: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getClientIpAddress(): Promise<string | undefined> {
  try {
    const ipResponse = await axios.get(IPIFY_API_URL);
    return ipResponse?.data?.ip;
  } catch {
    return undefined;
  }
}

/**
 * Retries saving user IP address with exponential backoff.
 * @param token - User authentication token
 * @param ipAddress - IP address to save
 * @param maxRetries - Maximum number of retry attempts (default 5)
 * @returns true if successful, false if all retries failed
 */
async function saveUserIpAddressWithRetry(
  token: string | undefined,
  ipAddress: string,
  maxRetries: number = 5
): Promise<boolean> {
  if (!token || !ipAddress) return false;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      await saveUserIpAddress(token, ipAddress);
      return true;
    } catch (error) {
      const isLastAttempt = attempt === maxRetries;
      if (isLastAttempt) {
        logThirdPartyError(new Error('Failed to save IP address after max retries'), {
          api: 'saveUserIpAddress',
          endpoint: SAVE_USER_IP_ADDRESS,
          ipAddress,
          attempt,
          maxRetries,
          error: error instanceof Error ? error.message : String(error),
        });
        return false;
      }
      // Exponential backoff: 100ms, 200ms, 400ms, 800ms, 1600ms
      const delayMs = 100 * Math.pow(2, attempt - 1);
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  return false;
}

/**
 * Fetches the user's IP from ipify, sends it to the backend with retries, and handles errors (logs only, non-throwing).
 * No-op if token is missing. Returns the IP address if successful.
 */
export async function saveUserIp(token: string | undefined): Promise<string | undefined> {
  if (!token) return undefined;
  try {
    const ipAddress = await getClientIpAddress();
    if (ipAddress) {
      const success = await saveUserIpAddressWithRetry(token, ipAddress, 5);
      if (success) {
        return ipAddress;
      }
    }
  } catch (error) {
    logThirdPartyError(new Error('Error fetching user IP address'), {
      api: 'ipify',
      endpoint: IPIFY_API_URL,
      error: error instanceof Error ? error.message : String(error),
    });
  }
  return undefined;
}

export async function getSubscriptionDetails(
  token: string | undefined,
  tenantMitSubscriptionId: string | undefined
) {
  try {
    const response = await axiosInstance.get<SubscriptionDetailResponse>(
      `${TENANT_SUBSCRIPTION}/${tenantMitSubscriptionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          tenantMitSubscriptionId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`${axiosError.response.data.message}`);
      } else {
        throw new Error(`${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getWalletHistory(token: string | undefined) {
  try {
    const response = await axiosInstance.get<WalletHistoryResponse>(`${RENT_CREDIT}/transactions`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function getDynamicOffers(
  token: string | undefined,
  amount: number | undefined,
  paymentMethodId?: string | null,
  cardCompanyTypeId?: string | null
) {
  if (!paymentMethodId) {
    throw new Error('paymentMethodId is required');
  }

  try {
    const response = await axiosInstance.get<GetDynamicOffersResponse>(`${POINT_TASKS}/dynamic`, {
      params: {
        amount,
        paymentMethodId,
        cardCompanyTypeId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function previewPaymentRewards(
  token: string | undefined,
  body: PreviewPaymentRewardsRequest
) {
  try {
    const response = await axiosInstance.post<PreviewPaymentRewardsResponse>(
      `${POINT_TASKS}/preview`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error previewing payment rewards: ${axiosError.response.data.message}`
        );
      }
      throw new Error(`Error previewing payment rewards: ${error.message}`);
    }
    throw new Error(`Unexpected error: ${error}`);
  }
}

export const getMobileAppDownloadUrl = async (token: string | undefined, phoneNumber: string) => {
  try {
    const response = await axiosInstance.post<{ message: string }>(
      `${TENANT_EMAILS}/mobileAppDownloadUrl`,
      {
        phoneNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<SubscriptionDetailResponse>;
      if (axiosError.response?.data) {
        throw new Error(
          `Error fetching points stats for user: ${axiosError.response.data.message}`
        );
      } else {
        throw new Error(`Error fetching points stats for user: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
};

export async function getReferralStats(token: string | undefined) {
  try {
    const response = await axiosInstance.get<ReferralStats>(GET_REFERRAL_STATS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<tenantDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting referral stats: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting referral stats: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting referral stats: ${error}`);
    }
  }
}

export async function cancelSubscription(
  token: string | undefined,
  tenantMitSubscriptionId: string | undefined
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${TENANT_SUBSCRIPTION}/${tenantMitSubscriptionId}/cancel`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tenantMitSubscriptionId,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to disable Autopay. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}

export async function updateTenantSubscriptionPaymentMethod(
  token: string | undefined,
  tenantMitSubscriptionId: string | undefined,
  tenantPaymentOptionId: string
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${TENANT_SUBSCRIPTION}/${tenantMitSubscriptionId}`,
      { tenantPaymentOptionId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const backendMessage = axiosError.response?.data?.message;
      throw new Error(
        formatApiErrorMessage(backendMessage, 'Failed to update Autopay payment method. Please try again.')
      );
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
}

export async function getProcessDate(
  token: string | undefined,
  date: string,
  dueDate: number,
  paymentType: string,
  tenantPaymentOptionId: string
) {
  console.log('date', date);
  const utcDate = dayjs().utc().format('YYYY-MM-DD HH:mm:ss');
  try {
    const response = await axiosInstance.get<{
      message: string;
      data: {
        processDate: string;
      };
    }>(GET_PROCESS_DATE, {
      params: {
        timestamp: utcDate,
        dueDate: dueDate,
        paymentType: paymentType,
        tenantPaymentOptionId: tenantPaymentOptionId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<tenantDetailsResponse>;
      if (axiosError.response && axiosError.response.data) {
        console.error('Axios error response data:', axiosError.response.data);
        throw new Error(`Error getting referral stats: ${axiosError.response.data.message}`);
      } else {
        console.error('Axios error message:', error.message);
        throw new Error(`Error getting referral stats: ${error.message}`);
      }
    } else {
      console.error('Unexpected error:', error);
      throw new Error(`Error getting referral stats: ${error}`);
    }
  }
}

export async function getEquifaxSubscribedBuildings(
  token: string | undefined,
  page: number,
  limit: number
) {
  try {
    const response = await axiosInstance.get<EquifaxSubscribedBuildingResponse>(
      SUBSCRIBED_BUILDINGS,
      {
        params: {
          page: page,
          limit: limit,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching subscribed buildings: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching subscribed buildings: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function addCompanyInformation(
  token: string | undefined,
  requestBody: {
    name?: string;
    displayName?: string;
    kycBusinessTypeId?: string | null;
    documentPath?: string;
    otherBusinessType?: string;
  }
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(TENANT_COMPANY, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        if (errorMessage === 'tenant_not_found') {
          throw new Error('Tenant Not found');
        } else {
          throw new Error(`Error adding Company Information: ${errorMessage}`);
        }
      } else {
        throw new Error(`Error adding Company Information: ${error.message}`);
      }
    } else {
      throw new Error(`Error adding Company Information: ${error}`);
    }
  }
}

export async function getKYCBusinessTypes(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{ kycBusinessTypeId: string; value: string }[]>(
      `${KYC_BUSINESS_TYPE}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching kyc business types: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching kyc business types: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function addStakeholder(
  token: string | undefined,
  requestBody: {
    email: string;
    firstName: string;
    lastName: string;
  }
) {
  try {
    const response = await axiosInstance.post<ApiResponse>(TENANT_STAKEHOLDER, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        const errorMessage = axiosError.response.data.message;
        if (errorMessage === 'tenant_not_found') {
          throw new Error('Tenant Not found');
        } else {
          throw new Error(`Error adding Company Information: ${errorMessage}`);
        }
      } else {
        throw new Error(`Error adding Company Information: ${error.message}`);
      }
    } else {
      throw new Error(`Error adding Company Information: ${error}`);
    }
  }
}
export async function getStakeholders(token: string | undefined) {
  try {
    const response = await axiosInstance.get<StakeholderResponse>(`${TENANT_STAKEHOLDER}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message: string }>;
      const message = axiosError.response?.data?.message || axiosError.message || 'Unknown error';
      throw new Error(`Error fetching stakeholders: ${message}`);
    } else {
      throw new Error(`Unexpected error: ${String(error)}`);
    }
  }
}
export async function deleteStakeholder(token: string | undefined, id: string | undefined) {
  try {
    const response = await axiosInstance.delete<ApiResponse>(`${TENANT_STAKEHOLDER}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error deleting stakeholder: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error deleting stakeholder: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}
export async function updateStakeholder(
  token: string | undefined,
  id: string | undefined,
  requestBody: {
    email: string;
    firstName: string;
    lastName: string;
  }
) {
  try {
    const response = await axiosInstance.patch<ApiResponse>(
      `${TENANT_STAKEHOLDER}/${id}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response && axiosError.response.data) {
        throw new Error(`Error updating stakeholder: ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error updating stakeholder: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function getTenantCompany(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{ message: string; data: TenantCompany }>(
      `${TENANT_COMPANY}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`Error fetching Tenant Company : ${axiosError.response.data.message}`);
      } else {
        throw new Error(`Error fetching Tenant Company: ${error.message}`);
      }
    } else {
      throw new Error(`Unexpected error: ${error}`);
    }
  }
}

export async function applyPromoCode(token: string | undefined, name: string) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${PROMO_CODES}`,
      { name }, // <-- send in body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`${axiosError.response.data.message}`);
      } else {
        throw new Error(`${error.message}`);
      }
    } else {
      throw new Error(`${error}`);
    }
  }
}

export async function getPromoCode(token: string | undefined) {
  try {
    const response = await axiosInstance.get<{
      message: string;
      data: {
        promoCodeId: string;
        name: string;
      };
    }>(
      `${PROMO_CODES}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data) {
        throw new Error(`${axiosError.response.data.message}`);
      } else {
        throw new Error(`${error.message}`);
      }
    } else {
      throw new Error(`${error}`);
    }
  }
}

export type SkillTestRequestError = {
  message: string;
  statusCode: number;
};

function normalizeSkillTestErrorMessage(message: unknown, fallback: string): string {
  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message) && message.length > 0) {
    return String(message[0]);
  }

  return fallback;
}

function toSkillTestRequestError(error: unknown): SkillTestRequestError {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<{ message?: string | string[] }>;
    return {
      message: normalizeSkillTestErrorMessage(
        axiosError.response?.data?.message,
        axiosError.message
      ),
      statusCode: axiosError.response?.status ?? 500,
    };
  }

  return {
    message: 'Unexpected error',
    statusCode: 500,
  };
}

function skillTestRequestHeaders(token: string) {
  return {
    'x-skill-token': token,
  };
}

export async function getSkillTest(token: string): Promise<SkillTestData> {
  try {
    const response = await axiosInstance.get<SkillTestResponse>(SKILL_TESTS_URL, {
      headers: skillTestRequestHeaders(token),
    });
    return response.data.data;
  } catch (error) {
    throw toSkillTestRequestError(error);
  }
}

export async function openSkillTest(token: string): Promise<SkillTestData> {
  try {
    await axiosInstance.patch<SkillTestMessageResponse>(
      SKILL_TESTS_URL,
      {},
      {
        headers: skillTestRequestHeaders(token),
      }
    );
  } catch (error) {
    throw toSkillTestRequestError(error);
  }

  return getSkillTest(token);
}

export async function submitSkillTestAnswer(
  token: string,
  answer: number
): Promise<SkillTestData> {
  try {
    await axiosInstance.post<SkillTestMessageResponse>(
      SKILL_TESTS_URL,
      { answer },
      {
        headers: skillTestRequestHeaders(token),
      }
    );
  } catch (error) {
    throw toSkillTestRequestError(error);
  }

  return getSkillTest(token);
}

export async function linkDescopeToTP(token: string | undefined) {
  try {
    const response = await axiosInstance.post<ApiResponse>(
      `${OAUTH_URL}/link`,
      {}, // body (empty if not needed)
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      if (axiosError.response?.data?.message) {
        throw new Error(axiosError.response.data.message);
      }
      throw new Error(error.message);
    }

    throw new Error(String(error));
  }
}

export const ANALYTICS_EVENT_URL = `${API_URL}/analytics`;

export type AnalyticsEventName =
  | 'buildingTypeSelection'
  | 'paymentMethodTypeSelection'
  | 'paymentMethodTransactionTypeSelection';

/**
 * Fire-and-forget analytics tracking. Never throws — a failed analytics call
 * must not surface to the user or interrupt the flow it's tracking.
 */
export function postAnalyticsEvent(
  token: string | undefined,
  eventName: AnalyticsEventName,
  value: string
): void {
  if (!token) return;
  axiosInstance
    .post(
      ANALYTICS_EVENT_URL,
      { name: eventName, value },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    .catch((error) => {
      logThirdPartyError(new Error('Error posting analytics event'), {
        api: 'postAnalyticsEvent',
        endpoint: ANALYTICS_EVENT_URL,
        error: error instanceof Error ? error.message : String(error),
        eventName,
        value,
      });
    });
}
